import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../Redux/sidebarSlice"; // Import the toggle action
// import Cookies from "js-cookie";
import Cookies from "universal-cookie";
import { jwtDecode } from "jwt-decode";

const Sidebar = () => {
  const [userRole, setUserRole] = useState(null);
  // Access the sidebar state from Redux
  const isMenuOpen = useSelector((state) => state.sidebar.isMenuOpen);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cookies = new Cookies();

  const handleLogout = () => {
    cookies.remove("jwtToken");
    navigate("/");
    location.reload();
  };

  useEffect(() => {
    const token = cookies.get("jwtToken");
    // console.log("token")
    const decodedToken = jwtDecode(token);
    console.log("Decoded Token: ", decodedToken);
    setUserRole(decodedToken.role);
  }, []);

  const menuItems = [
    {
      title: "DonateGreat",
      items: [
        {
          label: "Dashboard",
          subItems: [
            { label: "Campaign Manager", link: "/dashboard" },
            { label: "New Fundraiser", link: "/dashboard/fundraiser" },
            ...(userRole === "admin"
              ? [{ label: "Settings", link: "/dashboard/settings" }]
              : []),
          ],
        },
      ],
    },
  ];

  return (
    <div
      id="default-sidebar"
      className={`absolute pt-2 z-44 h-full bg-gray-800 text-white transition-all duration-300 ease-in-out transform ${
        isMenuOpen ? "translate-x-0 w-64" : "-translate-x-full w-10 "
      } sm:translate-x-0 sm:relative md:fixed  shadow-lg`}
      aria-label="Sidebar"
    >
      {/* Sidebar Open/Close Button */}
      <button
        onClick={() => dispatch(toggleSidebar())} // Dispatch the toggle action
        className="text-white absolute top-4 right-2 p-2 focus:outline-none z-50 text-lg"
      >
        {isMenuOpen ? "✕" : "☰"}
      </button>

      {/* Sidebar Content */}
      {isMenuOpen && (
        <div className="flex flex-col justify-between h-full">
          <ul className="pc-navbar">
            {menuItems.map((section, sectionIndex) => (
              <React.Fragment key={sectionIndex}>
                <li className="pc-item pc-caption">
                  <label className="block px-4 py-2 text-gray-400 uppercase">
                    {section.title}
                  </label>
                </li>
                {section.items.map((item, itemIndex) => (
                  <li className="pc-item pc-hashmenu" key={itemIndex}>
                    <Link
                      to={item.link || "/dashboard"}
                      className="pc-link flex items-center px-4 py-2"
                    >
                      <span className="pc-mtext">{item.label}</span>
                    </Link>
                    {item.subItems && item.subItems.length > 0 && (
                      <ul className="pc-submenu ml-4 pl-4 border-l border-gray-600">
                        {item.subItems.map((subItem, subItemIndex) => (
                          <li className="pc-item" key={subItemIndex}>
                            <Link
                              to={subItem.link}
                              className="pc-link block px-4 py-2 hover:bg-gray-700"
                            >
                              {subItem.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </React.Fragment>
            ))}
          </ul>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className=" ml-12 mb-2 w-2/4 bg-gray-700 rounded-lg text-white py-2 text-center hover:bg-gray-500 hover:scale-105 absolute bottom-0"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
